import { em, math } from 'polished'
import styled from 'styled-components'

export const Item = styled.div`
  position: absolute;

  &.item-0 {
    top: 10%;
  }

  &.item-1 {
    top: 24%;
  }

  &.item-2 {
    top: 39%;
  }

  &.item-3 {
    top: 51%;
  }
`

export const LineWrapper = styled(Item)`
  display: inline-block;
  transform: translateX(-100%);
  height: ${p => math(`${em(16)} * ${p.theme.typography.baseLh}`)};

  &.line-0 {
    width: 26%;
  }

  &.line-1 {
    width: 23%;
  }

  &.line-2 {
    width: 22%;
  }

  &.line-3 {
    width: 43%;
  }
`
